import { useState } from "react";
import { Col, Collapse, Row } from "reactstrap";
import { SharedMediaTitle } from "../../../../Constants/Constants";
import { MediaItemsData } from "../../../../Data/Bonus/Elements";
import { dynamicImage, Image } from "../../../../Utils";

const SharedMedia = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Col md="6" sm="12">
      <div className="element-card">
        <div className="element-card-header heading">
          <h2>{SharedMediaTitle}</h2>
        </div>
        <div className="element-card-body typography">
          <div className="collapse-block open">
            <h5 className="block-title" onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: "1rem" }}>{SharedMediaTitle}</h5>
            <Collapse className="block-content" isOpen={isOpen}>
              <div className="share-media">
                <Row>
                  {MediaItemsData.map((item, index) => (
                    <Col xs="4" key={index}>
                      {item.map((data, index) => (
                        <div className={`media-${data.size}`} key={index} style={{ backgroundImage: `url(${dynamicImage(data.src)})`, backgroundSize: "cover", backgroundPosition: "center center", display: "block" }}>
                          <Image className="bg-img" src={dynamicImage(data.src)} alt="Avatar" style={{display:"none"}}/>
                        </div>
                      ))}
                    </Col>
                  ))}
                </Row>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default SharedMedia;
